import Image from "next/image";
import Link from "next/link";

export function FunnelLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen flex-col  bg-white-80">
      <nav className="flex border-b border-neutral-90 bg-white-80 p-5 md:px-7 md:py-6">
        <Link href="/">
          <Image
            width={97}
            height={24}
            src="/logos/marble-logo.svg"
            alt="Marble logo"
            className="w-[64px] md:w-[97px]"
          />
        </Link>
      </nav>
      <main className="h-full">{children}</main>
    </div>
  );
}
